module.exports = __webpack_public_path__ + "static/media/padletur.a61e33f7.jpg";